function initThumbsGallery() {



}

initThumbsGallery();